"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LocationOffTarget: ['location-off-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.126,18.26A6.606,6.606,0,0,1,5.741,9.877a1.225,1.225,0,0,0-2.317-.794,8.628,8.628,0,0,0-.331,1.29.49.49,0,0,1-.482.4H1.224a1.224,1.224,0,0,0,0,2.448h1.39a.489.489,0,0,1,.481.4A9.069,9.069,0,0,0,10.373,20.9a.491.491,0,0,1,.4.482v1.39a1.224,1.224,0,0,0,2.448,0V21.39a.489.489,0,0,1,.4-.482,9.026,9.026,0,0,0,1.289-.33,1.224,1.224,0,1,0-.79-2.318Z', 'M19.508,17.776a.488.488,0,0,1-.057-.624,8.989,8.989,0,0,0,1.454-3.525.49.49,0,0,1,.482-.4h1.389a1.224,1.224,0,0,0,0-2.448h-1.39a.489.489,0,0,1-.481-.4A9.069,9.069,0,0,0,13.627,3.1a.491.491,0,0,1-.4-.482V1.224a1.224,1.224,0,0,0-2.448,0V2.613a.489.489,0,0,1-.4.481A8.972,8.972,0,0,0,6.852,4.552.489.489,0,0,1,6.227,4.5L2.09.359A1.224,1.224,0,0,0,.359,2.09L21.91,23.641a1.224,1.224,0,1,0,1.731-1.731ZM12,5.388a6.6,6.6,0,0,1,5.793,9.788.489.489,0,0,1-.775.11L8.712,6.98a.489.489,0,0,1,.11-.775A6.558,6.558,0,0,1,12,5.388Z']],
  LocationUser: ['location-user', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.1,14.25a.253.253,0,0,0-.189.051.246.246,0,0,0-.1.171L15.58,16.7a.249.249,0,0,0,.207.272c2.309.383,3.867,1.105,3.867,1.933,0,1.229-3.427,2.225-7.654,2.225s-7.654-1-7.654-2.225c0-.828,1.558-1.55,3.867-1.933A.249.249,0,0,0,8.42,16.7l-.231-2.226a.246.246,0,0,0-.1-.171.253.253,0,0,0-.189-.051c-4.292.615-7.9,2.2-7.9,4.653,0,3.211,6.178,4.944,11.991,4.944S23.991,22.114,23.991,18.9C23.991,16.45,20.387,14.865,16.1,14.25Z', 'M9.250 2.903 A2.750 2.750 0 1 0 14.750 2.903 A2.750 2.750 0 1 0 9.250 2.903 Z', 'M9,13.153h.77a.249.249,0,0,1,.249.229l.443,5.312a.5.5,0,0,0,.5.459h2.08a.5.5,0,0,0,.5-.459l.443-5.312a.249.249,0,0,1,.249-.229H15a.5.5,0,0,0,.5-.5v-2.5a3.5,3.5,0,0,0-7,0v2.5A.5.5,0,0,0,9,13.153Z']],
  LocationTarget1: ['location-target-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12.25A1.25,1.25,0,0,0,22.75,11h-.913a.5.5,0,0,1-.493-.412,9.516,9.516,0,0,0-7.919-7.73A.5.5,0,0,1,13,2.364V1.25a1.25,1.25,0,0,0-2.5,0V2.464a.5.5,0,0,1-.4.489,9.51,9.51,0,0,0-7.444,7.634A.5.5,0,0,1,2.164,11H1.25a1.25,1.25,0,0,0,0,2.5h.914a.5.5,0,0,1,.492.413A9.51,9.51,0,0,0,10.1,21.547a.5.5,0,0,1,.4.489v.714a1.25,1.25,0,0,0,2.5,0v-.614a.5.5,0,0,1,.425-.494,9.515,9.515,0,0,0,7.919-7.729.5.5,0,0,1,.492-.413h.914A1.25,1.25,0,0,0,24,12.25ZM12,19.5a7.25,7.25,0,1,1,7.25-7.25A7.258,7.258,0,0,1,12,19.5Z']],
  LocationTarget: ['location-target', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.000 12.000 A4.000 4.000 0 1 0 16.000 12.000 A4.000 4.000 0 1 0 8.000 12.000 Z', 'M23,11H21.377a.5.5,0,0,1-.493-.421,9.017,9.017,0,0,0-7.463-7.463A.5.5,0,0,1,13,2.623V1a1,1,0,0,0-2,0V2.623a.5.5,0,0,1-.421.493,9.017,9.017,0,0,0-7.463,7.463A.5.5,0,0,1,2.623,11H1a1,1,0,0,0,0,2H2.623a.5.5,0,0,1,.493.421,9.017,9.017,0,0,0,7.463,7.463.5.5,0,0,1,.421.493V23a1,1,0,0,0,2,0V21.377a.5.5,0,0,1,.421-.493,9.017,9.017,0,0,0,7.463-7.463A.5.5,0,0,1,21.377,13H23a1,1,0,0,0,0-2ZM12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z']]
};
exports["default"] = _default;